// extracted by mini-css-extract-plugin
export const cards = "results-module--cards--2QFfZ";
export const cta = "results-module--cta--AcuAj";